import { Component } from '@theme/component';

/**
 * Tap-to-play rail of customer videos for the 7 Reasons Why LP.
 * One video plays at a time; tapping the playing card pauses it.
 */
class UgcRail extends Component {
  /** @type {HTMLVideoElement | null} */
  #current = null;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('ended', this.#handleStop, true);
    this.addEventListener('pause', this.#handleStop, true);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('ended', this.#handleStop, true);
    this.removeEventListener('pause', this.#handleStop, true);
  }

  /**
   * @param {Event} event
   */
  toggle(event) {
    const card = event.target instanceof Element ? event.target.closest('.srw-ugc__card') : null;
    const video = card?.querySelector('video');
    if (!card || !video) return;

    if (!video.paused) {
      video.pause();
      return;
    }

    if (this.#current && this.#current !== video) this.#current.pause();

    this.#current = video;
    this.#setPlaying(card, true);
    video.play().catch(() => this.#setPlaying(card, false));
  }

  /**
   * @param {Event} event
   */
  #handleStop = (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement)) return;

    const card = video.closest('.srw-ugc__card');
    if (card) this.#setPlaying(card, false);
    if (this.#current === video) this.#current = null;
  };

  /**
   * @param {Element} card
   * @param {boolean} playing
   */
  #setPlaying(card, playing) {
    card.classList.toggle('srw-ugc__card--playing', playing);
    card.querySelector('.srw-ugc__play')?.setAttribute('aria-pressed', String(playing));
  }
}

if (!customElements.get('srw-ugc-rail')) {
  customElements.define('srw-ugc-rail', UgcRail);
}
